/**
 * Parse a CSV header line into trimmed column names. Handles bare commas
 * and basic double-quoted fields (e.g. "name, with comma"). For complex
 * CSVs (escaped quotes inside quoted fields beyond doubled-double-quote,
 * embedded newlines, etc.) the user can paste headers one per line.
 */
export function parseCsvHeader(line: string): string[] {
  const headers: string[] = [];
  let i = 0;
  let cur = '';
  let inQ = false;
  while (i < line.length) {
    const ch = line[i];
    if (inQ) {
      if (ch === '"' && line[i + 1] === '"') {
        cur += '"';
        i += 2;
        continue;
      }
      if (ch === '"') {
        inQ = false;
        i++;
        continue;
      }
      cur += ch;
      i++;
      continue;
    }
    if (ch === '"') {
      inQ = true;
      i++;
      continue;
    }
    if (ch === ',') {
      headers.push(cur.trim());
      cur = '';
      i++;
      continue;
    }
    cur += ch;
    i++;
  }
  headers.push(cur.trim());
  return headers.filter(Boolean);
}
